export default __webpack_public_path__ + "static/media/monkey13.66d9e549.jpeg";